export const optionalTour = {
  optionalTourCategory: "テーマ",
  category: "テーマ",
  query: "キーワード",
  region: "目的地",
};
